// extracted by mini-css-extract-plugin
export default {"blog-post":"BlogPostPage_blog-post__pxblG","blog_post":"BlogPostPage_blog_post__wZdG9"};